export default __webpack_public_path__ + "static/media/logo_min.fb699871.png";